import { BoxProps, StylesOptions } from '@mos-cat/ds';
import { pxToRem } from '@mos-cat/ds-theme';

type StyleType = Record<string, unknown>;
type AdditionalStyleType = [boolean, StyleType];

const combineStyles = (
  baseStyle: StyleType,
  ...additionalStyles: AdditionalStyleType[]
): StyleType => {
  let styles = { ...baseStyle };
  additionalStyles.forEach(([condition, style]) => {
    if (condition) {
      styles = { ...styles, ...style };
    }
  });
  return styles;
};

const WHCM =
  '@media (-ms-high-contrast: active), (prefers-contrast: more), (forced-colors: active)';
const WHCMstyles = {
  msHighContrastAdjust: 'none',
  forcedColorAdjust: 'none',
} as StylesOptions['styles'];

type Props = {
  isSelected: boolean;
  isInInterval: boolean;
};
const dayStyles = ({ isSelected, isInInterval }: Props) =>
  combineStyles(
    {
      size: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 'fs-14',
      lineHeight: 'calendarBtnLineHeight',
      backgroundColor: 'calendarBtnBg',
      color: 'calendarBtnText',
      fontFeatureSettings: "'tnum'",
    },
    [
      isSelected,
      {
        backgroundColor: 'calendarBtnSelectedBg',
        color: 'calendarSelectedText',

        [WHCM]: {
          ...WHCMstyles,
          backgroundColor: 'WindowText',
          color: 'Window',
        },
      },
    ],
    [
      isInInterval,
      {
        backgroundColor: 'calendarIntervalBg',
        [WHCM]: {
          ...WHCMstyles,
          backgroundColor: 'WindowText',
          color: 'Window',
        },
      },
    ],
  );

const dayWrapper: BoxProps = {
  p: 0,
  position: 'relative',
  maxWidth: pxToRem(39),
  width: '100vw',
  border: 1,
  borderColor: 'calendarBtnBorderColor',
  styles: {
    '&:before': {
      content: '""',
      float: 'left',
      paddingTop: '100%',
    },
  },
};

export default {
  dayWrapper,
  dayStyles,
};
